import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Content = styled.div`
  background: #ffffff;
  box-shadow: 0px 1px 3px 1px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  width: 100%;
  padding: 5px 10px;
  min-height: 40px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  > * {
    padding: 5px 0;
  }
`;

const Title = styled.div`
  padding-top: 13px;
  font-size: 14px;
  font-weight: 600;
`;

const WithoutTravelContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export { Container, Content, Title, WithoutTravelContent };
